import { getWindow } from 'ssr-window';

export default function Resize({ swiper, on, emit }) {
  const window = getWindow();
  let observer = null;
  let animationFrame = null;

  const resizeHandler = () =&gt; {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  const createObserver = () =&gt; {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver((entries) =&gt; {
      animationFrame = window.requestAnimationFrame(() =&gt; {
        const { width, height } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({ contentBoxSize, contentRect, target }) =&gt; {
          if (target &amp;&amp; target !== swiper.el) return;
          newWidth = contentRect
            ? contentRect.width
            : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect
            ? contentRect.height
            : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  const removeObserver = () =&gt; {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer &amp;&amp; observer.unobserve &amp;&amp; swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  const orientationChangeHandler = () =&gt; {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () =&gt; {
    if (swiper.params.resizeObserver &amp;&amp; typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });

  on('destroy', () =&gt; {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}
